/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com
 */

// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import { VDataTableServer } from "vuetify/components";
import { VDataTable } from "vuetify/components";
import { VSkeletonLoader } from "vuetify/components";
import { VDatePicker } from "vuetify/components";
import { VStepper } from "vuetify/components";
import { VNavigationDrawer } from "vuetify/components";
import { VCardItem } from "vuetify/components";
import { VCardText } from "vuetify/components";
import { VCardTitle } from "vuetify/components";
import { VCardActions } from "vuetify/components";
import { VCardSubtitle } from "vuetify/components";
import { VSelect } from "vuetify/components";
import { VImg } from "vuetify/components";
import { VAvatar } from "vuetify/components";
import { VIcon } from "vuetify/components";
import { VContainer } from "vuetify/components";
import { VBtn } from "vuetify/components";
import { VCol } from "vuetify/components";
import { VRow } from "vuetify/components";
import { VList } from "vuetify/components";
import { VListItem } from "vuetify/components";
import { VSnackbar } from "vuetify/components";
import { VSnackbarQueue } from "vuetify/components";
import { VChip } from "vuetify/components";
import { VProgressLinear } from "vuetify/components";
import { VDialog } from "vuetify/components";
import { VToolbar } from "vuetify/components";
import { VLayout } from "vuetify/components";
import { VOverlay } from "vuetify/components";
import { VHover } from "vuetify/components";
import { VCarousel } from "vuetify/components";
import { VCarouselItem } from "vuetify/components";
import { VMenu } from "vuetify/components";
import { VCheckbox } from "vuetify/components";
import { VSpacer } from "vuetify/components";
import { VTextField } from "vuetify/components";
import { VMain } from "vuetify/components";
import { VSheet } from "vuetify/components";
import { VTab } from "vuetify/components";
import { VWindow } from "vuetify/components";
import { VWindowItem } from "vuetify/components";
import { VForm } from "vuetify/components";
import { VSwitch } from "vuetify/components";
import { VTimeline } from "vuetify/components";
import { VTimelineItem } from "vuetify/components";
import { VExpansionPanel } from "vuetify/components";
import { VExpansionPanels } from "vuetify/components";
import { VExpansionPanelTitle } from "vuetify/components";
import { VExpansionPanelText } from "vuetify/components";
import { VRadioGroup } from "vuetify/components";
import { VRadio } from "vuetify/components";
import { VTooltip } from "vuetify/components";
import { VCombobox } from "vuetify/components";
import { VListItemTitle } from "vuetify/components";
import { VInput } from "vuetify/components";
import { VProgressCircular } from "vuetify/components";
import { VAppBar } from "vuetify/components";
import { VApp } from "vuetify/components";
import { VAppBarNavIcon } from "vuetify/components";
import { VDivider } from "vuetify/components";

// Composables
import { createVuetify } from "vuetify";

export default createVuetify({
  components: {
    VDataTable,
    VDataTableServer,
    VSkeletonLoader,
    VDatePicker,
    VStepper,
    VCard: {
      variant: "flat",
    },
    VNavigationDrawer,
    VCardItem,
    VCardText,
    VCardTitle,
    VCardActions,
    VCardSubtitle,
    VSelect,
    VImg,
    VAvatar,
    VIcon,
    VBtn,
    VContainer,
    VCol,
    VRow,
    VList,
    VListItem,
    VSnackbar,
    VSnackbarQueue,
    VChip,
    VProgressLinear,
    VDialog,
    VToolbar,
    VLayout,
    VApp,
    VAppBar,
    VAppBarNavIcon,
    VOverlay,
    VHover,
    VCarousel,
    VCarouselItem,
    VMenu,
    VCheckbox,
    VSpacer,
    VTextField,
    VMain,
    VSheet,
    VTab,
    VWindow,
    VWindowItem,
    VForm,
    VSwitch,
    VTimeline,
    VTimelineItem,
    VExpansionPanel,
    VExpansionPanels,
    VExpansionPanelTitle,
    VExpansionPanelText,
    VRadioGroup,
    VRadio,
    VTooltip,
    VCombobox,
    VListItemTitle,
    VInput,
    VProgressCircular,
    VDivider,
  },
  defaults: {
    VDataTable: {
      density: "compact",
      variant: "outlined",
    },
    VProgressCircular: {},
    VListItemTitle: {},
    VInput: {
      density: "compact",
      variant: "outlined",
    },
    VDivider: {},
    VTooltip: {},
    VRadio: {},
    VRadioGroup: {},
    VExpansionPanel: {},
    VExpansionPanels: {},
    VExpansionPanelTitle: {},
    VExpansionPanelText: {},
    VTimeline: {},
    VTimelineItem: {},
    VSwitch: {
      density: "compact",
      variant: "outlined",
    },
    VForm: {},
    VWindow: {},
    VWindowItem: {},
    VTab: {},
    VSheet: {},
    VMain: {},
    VSpacer: {},
    VCheckbox: {},
    VCarousel: {},
    VCarouselItem: {},
    VMenu: {},
    VHover: {},
    VOverlay: {},
    VApp: {},
    VAppBar: {},
    VAppBarNavIcon: {},
    VLayout: {},
    VToolbar: {},
    VDialog: {},
    VProgresslinear: {},
    VChip: {
      variant: "tonal",
    },
    VSnackbar: {},
    VSnackbarQueue: {},
    VListItem: {
      density: "compact",
    },
    VList: {
      density: "compact",
    },
    VRow: {},
    VCol: {},
    VContainer: {},
    VAvatar: {},
    VImg: {},
    VIcon: {},
    VCardText: {},
    VCardTitle: {},
    VCardSubtitle: {},
    VCardItem: {},
    VNavigationDrawer: {
      density: "compact",
    },
    VTextField: {
      density: "compact",
      variant: "outlined",
    },
    VSelect: {
      density: "compact",
      variant: "outlined",
    },
    VCombobox: {
      density: "compact",
      variant: "outlined",
    },
    VTextarea: {
      density: "compact",
      variant: "outlined",
    },
    VDatePicker: {},
    VCard: {
      rounded: "lg",
      flat: true,
    },
    VSkeletonLoader: {
      elevation: "0",
    },
    VBtn: {
      variant: "flat",
      class: "px-5",
    },
  },

  theme: {
    defaultTheme: "light",
    themes: {
      light: {
        dark: false,
        colors: {
          background: "#eeeeee",
          surface: "#ffffff",
          primaryLight: "#FFE082",
          primary: "#FF6F00",
          "on-background": "#212121",
          "on-surface": "#212121",
          "on-primary": "#ffffff",
          secondary: "#5c5c5c",
          "on-secondary": "#ffffff",
          accent: "#82B1FF",
          error: "#ef5350",
          "on-error": "#ffffff",
          info: "#42A5F5",
          "on-info": "#ffffff",
          success: "#66BB6A",
          "on-success": "#ffffff",
          warning: "#F9A825",
          lightblue: "#c7ebff",
        },
      },
    },
  },
});
